module.exports = __webpack_public_path__ + "img/groupisok.a5bdea91.png";